export default __webpack_public_path__ + "static/media/agent.5a6d9e78.svg";